import * as types from "./types";

export default {
  [types.CERTIFICATE_TYPES]: (state) => {
    return state.certificateTypes;
  },
  [types.CERTIFICATES_SEARCH_RESULT]: (state) => {
    return state.certificatesSearchResult;
  },
  [types.NEW_CERTIFICATE_TYPE_SIDEBAR]: (state) => { 
    return state.newCertificateTypeSidebar; 
  },
  [types.MANAGE_CERTIFICATE_TYPES_SIDEBAR]: (state) => {
    return state.manageCertificateTypesSidebar;
  },
}
